export const getBearer = () => {
  const storageData = localStorage.getItem('mage-cache-storage');

  if (storageData) {
    try {
      const parsedData = JSON.parse(storageData);
      const token = parsedData?.customer?.signin_token;

      if (token) {
        return `Bearer ${token}`;
      } else {
        console.error('No signin_token found in the object');
        return null;
      }
    } catch (error) {
      console.error('Error parsing localStorage data:', error);
      return null;
    }
  } else {
    console.error('No data found in localStorage for this key');
    return null;
  }
};
